var render = function render() {
        var _vm = this,
            _c = _vm._self._c;return _c('permission-manager', { attrs: { "latchkey": "dm" } }, [_c('div', { staticStyle: { "display": "flex" } }, [_c('pt-button', { staticClass: "download-button", attrs: { "loading": _vm.downloadLoading }, on: { "click": _vm.handleDownload } }, [_vm._v("\n      " + _vm._s("" + _vm.$t('common.download.text')) + "\n    ")]), _vm._v(" "), _c('product-info-verify', { ref: "productInfoVerifyRef", attrs: { "data": {
                                id: _vm.id,
                                promoted_type: _vm.promotedType || '',
                                name: _vm.templateConfig.name
                        }, "isCustom": !_vm.isCommonTemplateCustom, "callback": function callback() {
                                _vm.download();
                        } }, on: { "changeLoading": function changeLoading($event) {
                                _vm.downloadLoading = $event;
                        }, "update": _vm.handleProductUpdate } })], 1)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };